/* Phone helpers for the home page (no effect on desktop: the dots are hidden by CSS above 820px).
   Adds page dots under the swipeable card rows: the hero's three capability cards and the four review tiles. */
(function () {
  'use strict';
  function dots(g, label, dark, opt) {
    if (!g) return false;
    if (g.getAttribute('data-wb-dots')) return true;
    g.setAttribute('data-wb-dots', '1');
    opt = opt || {};
    var n = g.children.length;
    if (n < 2) return true;
    var wrap = document.createElement('div');
    wrap.className = 'wb-dots' + (dark ? ' dark' : '') + (opt.cls ? ' ' + opt.cls : '');
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', label);
    var btns = [];
    function go(i) {
      var c = g.children[i];
      g.scrollTo({ left: c.offsetLeft - (g.clientWidth - c.clientWidth) / 2, behavior: 'smooth' });
    }
    for (var i = 0; i < n; i++) {
      (function (k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Afficher la carte ' + (k + 1));
        if (opt.cls) b.className = 'wb-dot';
        b.addEventListener('click', function () { go(k); });
        wrap.appendChild(b);
        btns.push(b);
      })(i);
    }
    /* arrows either side of the dots: they show the cards can be moved, and work with a mouse */
    var current = 0;
    if (opt.arrows) {
      var arrow = function (dir) {
        var a = document.createElement('button');
        a.type = 'button'; a.className = 'wb-arrow';
        a.setAttribute('aria-label', dir < 0 ? 'Carte pr\u00e9c\u00e9dente' : 'Carte suivante');
        a.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="' + (dir < 0 ? 'M10 3 5 8l5 5' : 'M6 3l5 5-5 5') + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        a.addEventListener('click', function () { go((current + dir + n) % n); });
        return a;
      };
      wrap.insertBefore(arrow(-1), wrap.firstChild);
      wrap.appendChild(arrow(1));
    }
    g.insertAdjacentElement('afterend', wrap);
    function update() {
      var mid = g.scrollLeft + g.clientWidth / 2, best = 0, bd = 1e9;
      for (var k = 0; k < n; k++) {
        var c = g.children[k], d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid);
        if (d < bd) { bd = d; best = k; }
      }
      current = best;
      btns.forEach(function (b, k) { b.setAttribute('aria-current', k === best ? 'true' : 'false'); });
    }
    g.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    /* moves by itself every few seconds (owner, Oct 31 2026: every 3 s, on phones and computers). Any touch, swipe, arrow or dot
       restarts the count, a mouse resting on the cards holds them, and nothing moves while the cards are off screen, the tab is
       hidden, or the visitor asked their device for less motion. */
    if (opt.auto) {
      var timer = 0, hold = false, seen = true;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var arm = function () {
        clearTimeout(timer);
        if (still) return;
        timer = setTimeout(function () { if (!hold && seen && !document.hidden) go((current + 1) % n); arm(); }, opt.auto);
      };
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { g.addEventListener(ev, arm, { passive: true }); });
      wrap.addEventListener('click', arm);
      g.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = true; });
      g.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hold = false; arm(); } });
      if (window.IntersectionObserver) new IntersectionObserver(function (es) { seen = es[es.length - 1].isIntersecting; }).observe(g);
      arm();
    }
    return true;
  }
  function setup() {
    /* the hero's three capability cards: in the card beside the form (with the 3D orbit on top), a carousel on every screen;
       in the old layout (no 3D orbit) only phones get the dots */
    var hf = document.querySelector('#hero .hero-feats');
    var inCard = hf && hf.closest('[style*="minmax(400px, 470px)"]');
    var a = dots(hf, 'Choisissez une fonction', false, inCard ? { cls: 'wb-dots-card', arrows: true, auto: 3000 } : null);
    var b = dots(document.querySelector('#reviews .rv-grid'), 'Choisissez un avis', true);
    return a && b;
  }
  var t = setInterval(function () { if (setup()) clearInterval(t); }, 300);
  setTimeout(function () { clearInterval(t); }, 20000);
})();

/* Section menu for the top bar (shown wherever the desktop link row is hidden). */
(function () {
  'use strict';
  function build() {
    var pill = document.querySelector('.nav-pill');
    if (!pill || pill.getAttribute('data-wb-menu')) return !!pill;
    var links = [].slice.call(pill.querySelectorAll('nav.nav-links a'));
    var buyLink = pill.querySelector('a.nav-buy') || [].slice.call(pill.querySelectorAll('a')).filter(function (x) { return /Buy AI Phone/.test(x.textContent); })[0];
    var right = buyLink ? buyLink.parentElement : null;
    if (!links.length || !right) return false;
    pill.setAttribute('data-wb-menu', '1');
    buyLink.classList.add('wb-buy'); right.classList.add('wb-navr');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'wb-menu-btn'; btn.setAttribute('aria-label', 'Ouvrir le menu des sections'); btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="wb-mb"><i></i><i></i><i></i></span><span class="wb-mx"><i></i><i></i></span>';
    right.appendChild(btn);
    var buy = buyLink;
    var panel = document.createElement('div');
    panel.className = 'wb-menu-panel'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Aller \u00e0 une section'); panel.hidden = true;
    var h = '<div class="wb-mp-top"><b>Aller \u00e0 une section</b></div>';
    links.forEach(function (a, i) { h += '<a href="' + a.getAttribute('href') + '"><em>' + (i < 9 ? '0' : '') + (i + 1) + '</em>' + a.textContent + '</a>'; });
    if (buy) h += '<a class="wb-mp-buy" href="' + buy.getAttribute('href') + '">' + buy.textContent.replace(/[→\s]+$/, '') + '</a>';
    var callLink = pill.querySelector('a.nav-cta-2');
    if (callLink) h += '<a class="wb-mp-call" href="' + callLink.getAttribute('href') + '">Appeler l\u2019AI Phone</a>';
    panel.innerHTML = h;
    document.body.appendChild(panel);
    function place() { var r = pill.getBoundingClientRect(); panel.style.top = Math.round(r.bottom + 8) + 'px'; }
    function close() { panel.hidden = true; btn.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
    function open() { place(); panel.hidden = false; btn.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); panel.hidden ? open() : close(); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !panel.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (!panel.hidden) place(); });
    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        var t = document.getElementById(href.slice(1));
        if (t) { e.preventDefault(); close(); var navH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-height')) || 90; window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - (navH - 6), behavior: 'smooth' }); return; }
      }
      close();
    });
    return true;
  }
  /* desktops and tablets keep the link row: as many links as fit stay in the bar, the rest are in the menu (the menu button only shows when some are missing).
     Phones never show the row. Nothing is ever cut: when the full row is a little too wide the space between the links tightens (down to 6px) before
     the last links move to the menu. The row sits in a box that clips what overflows, so every title that stays must fit entirely. */
  var GAP0 = null, MIN_GAP = 6;
  function fit() {
    if (window.WB_PHONE) return;
    var pill = document.querySelector('.nav-pill'); if (!pill) return;
    var nav = pill.querySelector('nav.nav-links'); if (!nav) return;
    var links = [].slice.call(nav.querySelectorAll('a'));
    if (GAP0 === null) GAP0 = nav.style.getPropertyValue('column-gap') || '';
    /* how many links fit in the room the row has right now, and with which spacing */
    function pack() {
      nav.style.setProperty('column-gap', GAP0);                     /* the design's own spacing first */
      links.forEach(function (a) { a.style.display = ''; });
      var cs = getComputedStyle(nav), natural = parseFloat(cs.columnGap || cs.gap) || 0, avail = nav.clientWidth - 2;
      var w = links.map(function (a) { return a.getBoundingClientRect().width; });
      for (var n = links.length; n >= 1; n--) {
        var sum = 0; for (var i = 0; i < n; i++) sum += w[i];
        var room = n > 1 ? (avail - sum) / (n - 1) : natural;
        if (sum <= avail && room >= MIN_GAP) return { shown: n, gap: Math.min(natural, room), natural: natural };
      }
      return { shown: 0, gap: natural, natural: natural };
    }
    /* first as if the menu button were not there (it takes room from the row): it only appears when the whole row cannot fit without it */
    pill.classList.remove('wb-links-cut');
    var r = pack();
    if (r.shown < links.length) { pill.classList.add('wb-links-cut'); r = pack(); }
    var shown = r.shown;
    if (shown < 3 && shown < links.length) shown = 0;              /* too little room for a useful row: the menu alone */
    links.forEach(function (a, k) { a.style.display = k < shown ? '' : 'none'; });
    if (shown && r.gap < r.natural) nav.style.setProperty('column-gap', (Math.floor(r.gap * 10) / 10) + 'px');
    pill.classList.toggle('wb-links-cut', shown < links.length);
  }
  /* Phones always use the phone bar. Tablets and computers keep the desktop bar as long as it fits: in a window too narrow for
     logo, call, buy, cart, language and menu, the bar switches to the phone version, and back to the desktop bar once the window
     is wide enough again. The layout's first guess (in the page head) is checked here by measuring the real bar. */
  var needW = 0;                                                    /* window width the desktop bar needed when it last did not fit */
  function setPhone(on) { window.WB_PHONE = on; document.documentElement.setAttribute('data-wb-device', on ? 'phone' : 'desktop'); }
  function overflow(pill) {
    var P = pill.getBoundingClientRect(), edge = P.right - (parseFloat(getComputedStyle(pill).paddingRight) || 0) + 1, worst = 0;
    [].forEach.call(pill.querySelectorAll('a > img, .nav-cta-2, .nav-buy, .wb-cartbtn, .wb-langbtn, .wb-menu-btn'), function (e) {
      if (getComputedStyle(e).display === 'none') return;
      var b = e.getBoundingClientRect(); if (b.width && b.right > edge) worst = Math.max(worst, b.right - edge);
    });
    return worst;
  }
  function check() {
    if (window.WB_PHONE_UA) return fit();
    var pill = document.querySelector('.nav-pill'); if (!pill) return;
    if (window.WB_PHONE) { if (needW && window.innerWidth < needW) return; setPhone(false); }
    fit();
    var over = overflow(pill);
    if (over > 0) { needW = window.innerWidth + Math.ceil(over) + 4; setPhone(true); }
  }
  var checkQueued = false;
  function queueCheck() { if (checkQueued) return; checkQueued = true; requestAnimationFrame(function () { checkQueued = false; check(); }); }
  window.wbFitNav = check;
  var ft = setInterval(check, 250);
  setTimeout(function () { clearInterval(ft); }, 20000);
  window.addEventListener('resize', queueCheck);
  window.addEventListener('load', check);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  /* anything that changes the room later (the language switch or the cart button arriving, a font loading) re-fits the row */
  var fitQueued = false;
  function queueFit() { if (fitQueued) return; fitQueued = true; requestAnimationFrame(function () { fitQueued = false; fit(); }); }
  if (window.ResizeObserver) {
    var watch = setInterval(function () {
      var nv = document.querySelector('.nav-pill nav.nav-links'); if (!nv) return;
      clearInterval(watch);
      var ro = new ResizeObserver(queueFit); ro.observe(nv); if (nv.parentElement) ro.observe(nv.parentElement);
    }, 300);
    setTimeout(function () { clearInterval(watch); }, 20000);
  }
  /* the top bar is revealed only once it is complete (logo, cart, language switch, menu button): it never shows half built and then fills in.
     The layout hides it with html.wb-nav-wait on shop pages and lifts that after 5 s whatever happens. */
  var navPoll = setInterval(function () {
    var root = document.documentElement;
    if (!root.classList.contains('wb-nav-wait')) { clearInterval(navPoll); return; }
    var pill = document.querySelector('.nav-pill'); if (!pill) return;
    var img = pill.querySelector('img');
    var done = (!img || (img.complete && img.naturalWidth > 0)) && pill.querySelector('.wb-cartbtn') && (!window.WB_LANG || pill.querySelector('.wb-langbtn')) && pill.querySelector('.wb-menu-btn');
    if (done) { try { check(); } catch (e) {} root.classList.remove('wb-nav-wait'); clearInterval(navPoll); }
  }, 60);
  setTimeout(function () { clearInterval(navPoll); document.documentElement.classList.remove('wb-nav-wait'); }, 4500);
  var t = setInterval(function () { if (build()) clearInterval(t); }, 300);
  setTimeout(function () { clearInterval(t); }, 20000);
})();

/* Coverage grid (phones): it no longer animates in at all (wb-mobile.css, Oct 27 2026), so the old delayed start is gone. */

/* Smaller consultant buttons on phones. */
(function () {
  'use strict';
  function tag() {
    [].forEach.call(document.querySelectorAll('a'), function (a) {
      if (/^\s*(Talk to an AI (Phone )?Consultant|Call Our AI Phone|Parler à un conseiller|Appelez notre AI Phone)/i.test(a.textContent)) a.classList.add('wb-sm-cta');
    });
  }
  var n = 0, t = setInterval(function () { tag(); if (++n > 40) clearInterval(t); }, 500);
})();

/* Off-screen pause: looping CSS animations and playing videos stop while they are out of view and carry on when they come back
   (phones ran warm: about 80 loops kept running off screen). One-shot entrance animations are left alone.
   Oct 27 2026: loops follow their OWN element, not their section (a tall section, like "Why WinBoost" with its map and bubbles,
   counted as on screen while its loops were screens away), and a loop that comes back is put exactly where it would have been
   had it never stopped, so staggered loops (the map's city pulses, the week grid) stay in step with each other. */
(function () {
  'use strict';
  if (!window.IntersectionObserver || !document.getAnimations) return;
  var seen = new WeakSet(), recs = new Map(), now = function () { return performance.now(); };
  function hold(a) { if (a.playState !== 'running' || a.__wbHeld) return; a.__wbCT = a.currentTime; a.__wbAt = now(); a.pause(); a.__wbHeld = 1; }
  function release(a) { if (!a.__wbHeld) return; a.__wbHeld = 0; try { if (a.__wbCT != null) a.currentTime = a.__wbCT + (now() - a.__wbAt); } catch (e) {} a.play(); }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var r = recs.get(e.target); if (!r) return;
      r.vis = e.isIntersecting;
      r.anims.forEach(function (a) { if (r.vis) release(a); else hold(a); });
    });
  }, { rootMargin: '200px 0px' });
  function scan() {
    recs.forEach(function (r, el) { if (!el.isConnected) { io.unobserve(el); recs.delete(el); } });
    document.getAnimations().forEach(function (a) {
      var t; try { t = a.effect && a.effect.getComputedTiming(); } catch (e) { return; }
      if (!t || t.iterations !== Infinity) return;
      var el = a.effect.target; if (!el || el.nodeType !== 1) return;
      var r = recs.get(el);
      if (!r) { r = { vis: null, anims: new Set() }; recs.set(el, r); io.observe(el); }
      if (!r.anims.has(a)) { r.anims.add(a); if (r.vis === false) hold(a); }
    });
  }
  /* videos follow their own place on screen */
  var vio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      v.__wbOff = !e.isIntersecting;
      if (!e.isIntersecting) { if (!v.paused && !v.ended) { v.pause(); v.__wbHeld = 1; } }
      else if (v.__wbHeld) { v.__wbHeld = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }, { rootMargin: '150px 0px' });
  function watchVideos() {
    [].forEach.call(document.querySelectorAll('video'), function (v) {
      if (seen.has(v)) return;
      seen.add(v); vio.observe(v);
      /* autoplay can start after the check, while the video is still out of view */
      v.addEventListener('playing', function () { if (v.__wbOff) { v.pause(); v.__wbHeld = 1; } });
    });
  }
  function pass() { watchVideos(); scan(); }
  pass();
  /* loops that start later (a tab opened, a card that renders late) are picked up on the next pass */
  var n = 0, w = setInterval(function () { pass(); if (++n > 15) { clearInterval(w); setInterval(pass, 4000); } }, 1000);
})();

/* Laptop screens (owner, Oct 30 2026: on 13" to 16" MacBooks "chaque container, tu peux le voir sans obstruction"): a few large blocks of the
   home page are shown a little smaller when they are taller than the screen under the top bar, so each one is seen whole. The design is the
   same, scaled as one piece (CSS zoom), never under 80%; screens tall enough see no change; phones and tablets are not concerned (under 1100px).
   "reflow" blocks keep their full width and lay out at the smaller scale; "shrink" blocks keep their exact layout and become a little narrower,
   centered (used where a portrait video would otherwise grow with the extra width). Text can wrap differently at another scale, so the scale is
   found by trying (the largest one that fits), never computed once: a computed value flip-flopped between two sizes. */
(function () {
  'use strict';
  var MIN = 0.8, queued = false;
  function nav() { var h = document.querySelector('header'); return h ? h.getBoundingClientRect().height : 90; }
  function set(e, s, shrink) {
    var on = s < 0.995;
    e.style.zoom = on ? s.toFixed(3) : '';
    if (shrink) { e.style.width = on ? (s * 100).toFixed(2) + '%' : ''; e.style.marginLeft = e.style.marginRight = on ? 'auto' : ''; }
  }
  /* the largest scale in [MIN, 1] at which height() fits in avail; at MIN when even that is not enough */
  function search(e, height, shrink, avail) {
    set(e, 1, shrink);
    if (avail >= 1e5 || height() <= avail) return 1;
    var lo = MIN, hi = 1;
    set(e, lo, shrink);
    if (height() > avail) return lo;
    for (var i = 0; i < 7; i++) { var mid = (lo + hi) / 2; set(e, mid, shrink); if (height() <= avail) lo = mid; else hi = mid; }
    set(e, lo, shrink);
    return lo;
  }
  function span(a, b) { return function () { var ta = a.getBoundingClientRect().top, bb = -Infinity; (b.length ? b : [b]).forEach(function (x) { if (x) bb = Math.max(bb, x.getBoundingClientRect().bottom); }); return bb - ta; }; }
  function own(e) { return function () { return e.getBoundingClientRect().height; }; }
  var q = function (s) { return document.querySelector(s); };
  var BLOCKS = [
    /* product configuration: its title and the Essentials row with the "Your AI Phone" card are seen together */
    function (avail) { var z = q('#products .cf-zone'), p = q('#products .cf-pick'), m = q('#products .cf-sum'); if (z && p) search(z, span(z, [p, m]), false, avail); },
    /* how it fits: the live call card and the video together with the row of steps above them when the screen allows, else at least the stage */
    function (avail) {
      var st = q('#how-it-fits .wf-stage'); if (!st) return;
      var cont = st.parentElement, rail = cont.children[0] !== st ? cont.children[0] : null;
      var pad = (parseFloat(getComputedStyle(cont).paddingTop) || 0) + (parseFloat(getComputedStyle(cont).paddingBottom) || 0);
      var both = rail ? function () { return span(rail, [st])() + pad; } : own(st);
      set(st, MIN, true);
      if (both() <= avail) search(st, both, true, avail); else search(st, own(st), true, avail);
    },
    /* opportunity calculator card */
    function (avail) { var c = q('#calculator .wrap > div'); if (c) search(c, own(c), false, avail); },
    /* pricing: both columns together, sized so the "When should your AI Phone answer?" card fits */
    function (avail) { var cv = q('#pricing .cv-dark'); var g = cv && cv.parentElement && cv.parentElement.parentElement; if (g) search(g, own(cv), false, avail); },
    /* "Let's talk" card */
    function (avail) { var c = q('#onboarding .lt-card'); if (c) search(c, own(c), false, avail); }
  ];
  function laptop() { return window.innerWidth >= 1100 && window.innerHeight < window.innerWidth && document.documentElement.getAttribute('data-wb-device') !== 'phone'; }
  function run() {
    queued = false;
    var avail = laptop() ? window.innerHeight - nav() - 24 : 1e6;   /* phones, tablets: everything back to 100% */
    BLOCKS.forEach(function (f) { try { f(avail); } catch (e) {} });
  }
  function queue() { if (queued) return; queued = true; requestAnimationFrame(run); }
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  /* blocks that render late or change height are measured again (the same answer comes back, so this settles at once) */
  var ro = window.ResizeObserver ? new ResizeObserver(queue) : null, watched = [];
  function watch() {
    ['#products .cf-pick', '#how-it-fits .wf-stage', '#calculator .wrap > div', '#pricing .cv-dark', '#onboarding .lt-card'].forEach(function (s) {
      var e = q(s); if (e && ro && watched.indexOf(e) < 0) { watched.push(e); ro.observe(e); }
    });
    queue();
  }
  watch();
  var n = 0, t = setInterval(function () { watch(); if (++n > 20) clearInterval(t); }, 750);
})();

/* Phones held upright (owner, Oct 31 2026: "Tu dois arranger toutes les sections"): a card that is still a little taller than the screen under
   the top bar is scaled down just enough to show whole, never under 87%, so the look stays the same. A card that would need more stays at full
   size: it is long by nature (a story, a quote) and is read by scrolling. The height used is the screen with Safari's bars shown (100svh: owner's
   iPhone, Oct 31 2026, cards ended under the bars), and it does not change while the bars slide in and out during a scroll. */
(function () {
  'use strict';
  var MIN = 0.87, queued = false, lastW = -1, probe = null;
  var q = function (s) { return document.querySelector(s); };
  var qa = function (s) { return [].slice.call(document.querySelectorAll(s)); };
  function cards() {
    var f = q('#hero form'), out = [f && f.parentElement];
    var fig = q('#problem .ao-figs-grid'), p = fig && fig.parentElement;
    while (p && p.id !== 'problem' && !/clamp\(32px/.test(p.getAttribute('style') || '')) p = p.parentElement;
    out.push(p && p.id !== 'problem' ? p : null);
    var inm = q('#inmarketing [style*="minmax(280px, 1fr)"]'); out.push(inm && inm.parentElement);
    out.push(q('#calculator [style*="surface-card-inverse"]'));
    out.push(q('#booking-roi .wb-in-up > [style*="border-radius"]'));
    out.push(q('#products .cf-entc'), q('#products .cf-sum'), q('#compare-old-way .cfl-ring'), q('#data-safe .wrap > div'));
    /* the two side-by-side comparisons, stacked on a phone: both sides on one screen */
    var vs = q('#winboost-effect [style*="minmax(0px, 1fr) auto minmax(0px, 1fr)"]') || q('#winboost-effect [style*="minmax(0, 1fr) auto minmax(0, 1fr)"]');
    out.push(vs, q('#bundle .wb-vs-card > div'));
    return out.concat(qa('.wbs-svc-g'), qa('.wb-pform'), qa('.pdp-facts')).filter(Boolean);
  }
  function phone() { return window.innerWidth <= 600 && window.innerHeight > window.innerWidth; }
  function screenH() {
    if (!probe && window.CSS && CSS.supports && CSS.supports('height', '100svh')) {
      probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100svh;visibility:hidden;pointer-events:none';
      document.body.appendChild(probe);
    }
    return (probe && probe.offsetHeight) || window.innerHeight;
  }
  function nav() { var h = q('header'); return h ? Math.max(56, h.getBoundingClientRect().bottom) : 90; }
  function set(e, s) {
    var on = s < 0.995;
    e.style.zoom = on ? s.toFixed(3) : '';
    if (on) { e.setAttribute('data-wb-pz', ''); e.style.setProperty('--wb-pz', s.toFixed(3)); }
    else { e.removeAttribute('data-wb-pz'); e.style.removeProperty('--wb-pz'); }
  }
  function h(e) { return e.getBoundingClientRect().height; }
  function fit(e, avail) {
    set(e, 1);
    if (avail < 1e5 && h(e) > avail) {
      set(e, MIN);
      if (h(e) > avail) set(e, 1);                                /* too long even at 87%: left as it is */
      else {
        var lo = MIN, hi = 1;
        for (var i = 0; i < 7; i++) { var mid = (lo + hi) / 2; set(e, mid); if (h(e) <= avail) lo = mid; else hi = mid; }
        set(e, lo);
      }
    }
    e.__wbH = h(e);
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function (list) {
    for (var i = 0; i < list.length; i++) { var e = list[i].target; if (Math.abs(h(e) - (e.__wbH || 0)) > 4) { queue(); return; } }
  }) : null, watched = [];
  function run() {
    queued = false;
    var on = phone(), avail = on ? screenH() - nav() - 16 : 1e6;
    cards().forEach(function (e) {
      if (ro && watched.indexOf(e) < 0) { watched.push(e); ro.observe(e); }
      if (!on && !e.style.zoom) return;
      try { fit(e, avail); } catch (x) {}
    });
  }
  function queue() { if (queued) return; queued = true; requestAnimationFrame(run); }
  /* only a change of width (turning the phone, resizing a window) refits; Safari's bars sliding in and out do not */
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; queue(); } });
  window.addEventListener('load', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  [300, 900, 1800, 3500, 6000].forEach(function (t) { setTimeout(queue, t); });
  lastW = window.innerWidth; queue();
})();

/* Hero above the fold (owner, Oct 31 2026): the 3D orbit tile is sized to the screen, so the first screen shows the headline, its
   paragraph and the whole tile, and on a computer also the top of the carousel and the form under it. Measured with the browser's bars
   shown (the first screen), and only at the top of the page or when the width changes: never while the visitor scrolls. */
(function () {
  'use strict';
  var lastW = -1, queued = false;
  function run() {
    queued = false;
    var t = document.querySelector('#hero .wb-hero-orbit');
    if (!t || (window.pageYOffset || 0) > 4) return;
    var vw = window.innerWidth, vh = window.innerHeight;
    var wide = vw >= 1000 && vh < vw;
    var top = t.getBoundingClientRect().top + (window.pageYOffset || 0);
    var room = vh - top - (wide ? 150 : 46);   /* phones: room for the rating line under the tile */
    var h = Math.max(wide ? 260 : 150, Math.min(wide ? 460 : 340, room));   /* small phones and phones held sideways: down to 150px */
    t.style.height = Math.round(h) + 'px';
  }
  function queue() { if (queued) return; queued = true; requestAnimationFrame(run); }
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; queue(); } });
  window.addEventListener('load', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  var n = 0, iv = setInterval(function () { queue(); if (++n > 16) clearInterval(iv); }, 250);
  lastW = window.innerWidth;
})();
